
// src/helpers/format-number.js

// format: signed separate_1000 decimal_1 decimal_2 decimal_3 thousand million prepend_unit
// decimal_1: 小数点以下1桁, decimal_2: 小数点以下2桁, decimal_3: 小数点以下3桁

function rightString(str, len) {
  return str.substr(str.length - len, len);
}

export function formatNumber(value, format = {}) {
  if (typeof value == 'undefined') return '-'
  if (format.thousand) value = value / 1000
  if (format.million)  value = value / 1000000

  var truncated = Math.floor(Math.abs(value))
  var fraction = Math.abs(value)-Math.floor(Math.abs(value)) + 0.0001
  var text = ''
  var fraction_text = ''
  if (format.signed || value < 0) text = (value >= 0 ? '+' : '-')

  if (format.decimal_1)
    fraction_text = '.' + (fraction * 10.0).toString().substr(0, 1)
  else if (format.decimal_2)
    fraction_text = '.' + rightString('0' + Math.round(fraction * 100.0, 1), 2)
  else if (format.decimal_3)
    fraction_text = '.' + rightString('00'+ Math.round(fraction * 1000.0), 3)
  else if (fraction >= 0.5)
    truncated += 1

  if (format.separate_1000)
    text = text + truncated.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + fraction_text
  else
    text = text + truncated.toString() + fraction_text

  return text
}

export function percent(value) {
  if (value == Infinity || typeof value != 'number' || (function(x){return x!=x})(value))
    return '-'
  else
    return formatNumber(Math.round(value * 1000)/10, { decimal_1: true })
}



// WEBPACK FOOTER //
// ./src/helpers/format-number.js